'use strict'

define ['./appbundlesTable.css'], () ->
  ($rootScope, ApplicationBundle, $cacheFactory, $uibModal, $state, Landlord) ->
    restrict: "E"
    template: require("./appbundlesTable.jade")
    scope:
      state: "@"
      displayed: "="
    link: (scope, element, attrs) ->
      Landlord.getMe().$promise.then (response) ->
        scope.landlord = response

      scope.is_loading = false
      scope.search_term = ""
      scope.mobile_view = window.innerWidth < 768

      scope.status_class_map =
        'I': 'sent-to-applicant'
        'P': 'partial'
        'S': 'submitted'
        'R': 'rejected'
        'A': 'accepted'

      scope.view_app = (appbundle) ->
        $state.go "root.dashboard.view_application", { application_id: appbundle.applications[0].id }

      scope.toggle_app_to_checked = (app) ->
        app.checked = !app.checked
        if app.checked
          action = 'add-app'
        else
          action = 'remove-app'
        $rootScope.$broadcast action, { app: app }

      $rootScope.$on 'refresh-appbundle-table', (event, data) ->
        scope.load_table()

      scope.view_application = (appbundle) ->
        $state.href('root.dashboard.view_application', { application_id: appbundle.applications[0].id })

      scope.load_table = () ->
        scope.is_loading = true
        $cacheFactory.get("$http").removeAll()

        if scope.state == 'active'
          is_archived = false
        else
          is_archived = true

        ApplicationBundle.query
          limit: 25
          offset: 0
          applications__is_removed: false
          applications__is_archived: is_archived
          for_datatable: true
        .$promise.then (appbundles) ->
          scope.displayed = appbundles.objects
          scope.is_loading = false

      scope.open_notes_modal = (app) ->
        scope.current_app = app

        $uibModal.open
          scope: scope
          template: require("./notesModal/notesModal.jade")
          controller: require("./notesModal/notesModal.coffee")
          windowClass: 'notes-modal'
        .result.then () ->
          scope.current_app = null

      scope.reset = () ->
        scope.search_term = ''

      scope.search = (search_term) ->
        scope.is_loading = true
        $cacheFactory.get("$http").removeAll()

        if scope.state == 'active'
          is_archived = false
        else
          is_archived = true

        ApplicationBundle.query
          limit: 25
          offset: 0
          applications__is_removed: false
          applications__is_archived: is_archived
          for_datatable: true
          search: search_term.trim()
        .$promise.then (appbundles) ->
          scope.displayed = appbundles.objects
          scope.is_loading = false

      scope.formatDate = (date) =>
        # To parse a date as UTC, append a Z
        new Date(date + 'Z')

      $rootScope.$on 'paginate', (event, data) ->
        if scope.state == data.state
          scope.is_loading = true
          ApplicationBundle.query
            limit: 25
            offset: data.offset
            applications__is_removed: false
            applications__is_archived: scope.state == 'archived'
            for_datatable: true
            search: scope.search_term.trim()
          .$promise.then (appbundles) ->
            scope.displayed = appbundles.objects
            scope.is_loading = false

      scope.$on 'mobile-app-search', (event, data) ->
        scope.search(data.search_term)



// WEBPACK FOOTER //
// ./directives/appbundlesTable/appbundlesTable.coffee